import { SET_STATISTICS } from "../actions/Types";

const initialState = {
  users: 0,
  projects: 0,
  counters: 0,
  counterTypes: 0,
  validCounters: 0,
  selledCounters: 0,
  totalConsumption: 0,
};

const StatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATISTICS:
      return action.payload;
    default:
      return state;
  }
};

export default StatisticsReducer;
